export default __webpack_public_path__ + "static/media/p2p-banners.8910c7bf.webp";